module.exports = __webpack_public_path__ + "img/topic-push-notification.000ff194.png";